import { render, staticRenderFns } from "./MatchList.vue?vue&type=template&id=6418f5ef&scoped=true&"
import script from "./MatchList.vue?vue&type=script&lang=js&"
export * from "./MatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418f5ef",
  null
  
)

export default component.exports